export const ESCALATION_SEVERITY = {
  LOW: 'low',
  MEDIUM: 'medium',
  HIGH: 'high',
  CRITICAL: 'critical',
};

export const ESCALATION_SEVERITY_LABELS = {
  [ESCALATION_SEVERITY.LOW]: 'Low',
  [ESCALATION_SEVERITY.MEDIUM]: 'Medium',
  [ESCALATION_SEVERITY.HIGH]: 'High',
  [ESCALATION_SEVERITY.CRITICAL]: 'Critical',
};

export const INITIAL_ESCALATION_FORM_STATE = {
  projectId: '',
  description: '',
  severity: ESCALATION_SEVERITY.MEDIUM,
};

